'use client';

import { Box } from '@ironhack/design-system2/components/box';
import { Text } from '@ironhack/design-system2/components/text';

import { type TopBanner } from '../top-banner';
import { Link } from '@/app/components/client/link';
import { usePageContext } from '@/hooks';

import type { ReactElement } from 'react';

type Props = { data: TopBanner };

const invalidPages = new Set([
  'apply',
  'campaign-form',
  'contact',
  'financing-form',
  'full-apply',
  'quiz',
  'quiz-match',
]);

const isInvalidPage = (pageType: string): boolean => invalidPages.has(pageType);

export const TopBannerClient = (props: Props): ReactElement | null => {
  const {
    data: { bannerText, linkText, target },
  } = props;

  const ctx = usePageContext();
  const { pageData } = ctx;
  const { gaPageType } = pageData;

  if (isInvalidPage(gaPageType)) return null;

  return (
    <Box
      bg="button.primary.enabled"
      color="yellow.100"
      id="top-banner"
      px={[2, null, 5]}
      py={1}
      textAlign="center"
    >
      <Text as="span">{bannerText}</Text>
      {linkText && (
        <>
          <Text as="span">{' - '}</Text>
          <Link
            {...target[0]}
            _hover={{ cursor: 'pointer' }}
            color="text.inverse"
            display="inline-flex"
            textDecorationColor="text.inverse"
            textDecorationLine="underline"
            textDecorationThickness="1px"
            textUnderlineOffset="2px"
          >
            {linkText}
          </Link>
        </>
      )}
    </Box>
  );
};
